import { GetGroupsDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectGroup = (props) => (
  <SelectFromQuery
    cache="Groups"
    placeholder="All Groups"
    query={GetGroupsDocument}
    selector={(data) => {
      return (data?.getFilters?.filters?.groups || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
      }));
    }}
    {...props}
  />
);

export default SelectGroup;
